@if (data.title) {
    <h2 mat-dialog-title>{{ data.title }}</h2>
}

<mat-dialog-content>{{ data.message }}</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">გაუქმება</button>
    <button mat-raised-button color="primary" type="button" (click)="confirm()">დადასტურება</button>
</mat-dialog-actions>
